import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AdminRoute from './components/AdminRoute';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Wishlist from './pages/Wishlist';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ProofLayerPage from './pages/ProofLayerPage';
import NotFound from './pages/NotFound';
import AdminLayout from './pages/admin/AdminLayout';
import AdminOverview from './pages/admin/Overview';
import AdminUsers from './pages/admin/Users';
import AdminWishlist from './pages/admin/Wishlist';
import AdminMfafDisputes from './pages/admin/MfafDisputes';
import AdminCreditProtectClaims from './pages/admin/CreditProtectClaims';
import AdminBusinessVerifications from './pages/admin/BusinessVerifications';
import AdminBusinessCreditApplications from './pages/admin/BusinessCreditApplications';
import AdminCreditBuilderApplications from './pages/admin/CreditBuilderApplications';
import AdminSettings from './pages/admin/Settings';

import HcaPage from './pages/modules/HcaPage';
import CreditBuilderPage from './pages/modules/CreditBuilderPage';
import CreditProtectPage from './pages/modules/CreditProtectPage';
import ScoreTradePage from './pages/modules/ScoreTradePage';
import MfafPage from './pages/modules/MfafPage';
import PerkVaultPage from './pages/modules/PerkVaultPage';
import EquityShieldPage from './pages/modules/EquityShieldPage';
import FamePage from './pages/modules/FamePage';
import CapitalPoolsPage from './pages/modules/CapitalPoolsPage';
import RealExPage from './pages/modules/RealExPage';
import CryptoWalletPage from './pages/modules/CryptoWalletPage';
import MarginLendingPage from './pages/modules/MarginLendingPage';
import SpecializedFinancePage from './pages/modules/SpecializedFinancePage';
import InsuranceProtectionPage from './pages/modules/InsuranceProtectionPage';
import AureusPensionPage from './pages/modules/AureusPensionPage';
import YieldVaultPage from './pages/modules/YieldVaultPage';
import LenderPortalPage from './pages/modules/LenderPortalPage';
import GamificationPage from './pages/modules/GamificationPage';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/proof-layer" element={<ProofLayerPage />} />

          <Route path="/modules/hca" element={<HcaPage />} />
          <Route path="/modules/credit-builder" element={<CreditBuilderPage />} />
          <Route path="/modules/credit-protect" element={<CreditProtectPage />} />
          <Route path="/modules/scoretrade" element={<ScoreTradePage />} />
          <Route path="/modules/mfaf" element={<MfafPage />} />
          <Route path="/modules/perkvault" element={<PerkVaultPage />} />
          <Route path="/modules/equity-shield" element={<EquityShieldPage />} />
          <Route path="/modules/fame" element={<FamePage />} />
          <Route path="/modules/capital-pools" element={<CapitalPoolsPage />} />
          <Route path="/modules/realex" element={<RealExPage />} />
          <Route path="/modules/crypto-wallet" element={<CryptoWalletPage />} />
          <Route path="/modules/margin-lending" element={<MarginLendingPage />} />
          <Route path="/modules/specialized-finance" element={<SpecializedFinancePage />} />
          <Route path="/modules/insurance-protection" element={<InsuranceProtectionPage />} />
          <Route path="/modules/aureus-pension" element={<AureusPensionPage />} />
          <Route path="/modules/yield-vault" element={<YieldVaultPage />} />
          <Route path="/modules/lender-portal" element={<LenderPortalPage />} />
          <Route path="/modules/gamification" element={<GamificationPage />} />

          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route index element={<AdminOverview />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="wishlist" element={<AdminWishlist />} />
            <Route path="mfaf-disputes" element={<AdminMfafDisputes />} />
            <Route path="credit-protect-claims" element={<AdminCreditProtectClaims />} />
            <Route path="business-verifications" element={<AdminBusinessVerifications />} />
            <Route path="business-credit-applications" element={<AdminBusinessCreditApplications />} />
            <Route path="credit-builder-applications" element={<AdminCreditBuilderApplications />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
